import { Easel } from 'create-es6-js';

const draw = {
  AlphaMapFilter: Easel.AlphaMapFilter,
  AlphaMaskFilter: Easel.AlphaMaskFilter,
  BlurFilter: Easel.BlurFilter,
  ColorFilter: Easel.ColorFilter,
  ColorMatrixFilter: Easel.ColorMatrixFilter,
  ColorMatrix: Easel.ColorMatrix,
  Filter: Easel.Filter,
  Matrix2D: Easel.Matrix2D,
  DisplayProps: Easel.DisplayProps,
  Point: Easel.Point,
  Rectangle: Easel.Rectangle,
  ButtonHelper: Easel.ButtonHelper,
  SpriteSheetBuilder: Easel.SpriteSheetBuilder,
  SpriteSheetUtils: Easel.SpriteSheetUtils,
  MovieClipPlugin: Easel.MovieClipPlugin,
  Bitmap: Easel.Bitmap,
  BitmapText: Easel.BitmapText,
  Container: Easel.Container,
  DisplayObject: Easel.DisplayObject,
  DOMElement: Easel.DOMElement,
  Graphics: Easel.Graphics,
  MovieClip: Easel.MovieClip,
  Shadow: Easel.Shadow,
  Shape: Easel.Shape,
  Sprite: Easel.Sprite,
  SpriteContainer: Easel.SpriteContainer,
  SpriteSheet: Easel.SpriteSheet,
  SpriteStage: Easel.SpriteStage,
  Stage: Easel.Stage,
  StageGL: Easel.StageGL,
  Text: Easel.Text,
};

export default draw;




// WEBPACK FOOTER //
// ./Draw/index.js